module.exports = __webpack_public_path__ + "static/media/8_3.25568120.png";